import React from 'react';
import { postOfficeRoutePaths } from './PostOffice.route.paths';
import Nav from './components/Nav';
import { PostOfficeContainer, PostOfficeWrapper } from './PostOffice.styles';
import { useTranslation } from '@shared/core';
import globalWindow from '@shared/core/globals';
import type { PostOfficeMessageType } from '@graphql/generated-base';
import { AdminHeaderBar, AdminHeaderBarSpacer } from '@apps/admin/components/AdminHeaderBar';
import { useNativeState } from '@shared/core/native';
import { useResponsive } from '@shared/utils/hooks/useResponsive';

type PostOfficeProps = Readonly<{
  eventHandle: string;
  draftType: PostOfficeMessageType;
  fromDashboard?: string;
  isThankYouMessageLoading: boolean;
}>;

export const PostOffice: React.FC<PostOfficeProps> = ({ eventHandle, children, draftType, fromDashboard, isThankYouMessageLoading }) => {
  const { t2 } = useTranslation('postOffice');
  const tHeader = t2('header');

  const { isNative } = useNativeState();
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });

  if (globalWindow.Intercom) {
    globalWindow.Intercom('update', { hide_default_launcher: true });
  }

  return (
    <PostOfficeContainer
      alignItems="flex-start"
      justifyContent="center"
    >
      <AdminHeaderBar
        title={tHeader[draftType as keyof typeof tHeader]}
        hideHamburger={isNative}
        nativePadding={isNative}
        hideLogo={isMobile}
      />
      <AdminHeaderBarSpacer />
      <PostOfficeWrapper>{children}</PostOfficeWrapper>
      <Nav
        eventHandle={eventHandle}
        routes={postOfficeRoutePaths}
        draftType={draftType}
        fromDashboard={fromDashboard}
        isThankYouMessageLoading={isThankYouMessageLoading}
      />
    </PostOfficeContainer>
  );
};
